import { useEffect } from 'react';

import Video from '../Video/Video.js';

import './MainVideo.css'

export default function MainVideo(props) {
    useEffect(() => {
        const header = document.querySelector('header');
        const video = props.videoRef.current;

        function fitVideoSize() {
            // Find height available
            let headerHeight = header.getBoundingClientRect().height;
            let fitHeight = window.innerHeight - headerHeight;

            // Update height
            video.style.height = `${fitHeight}px`;
        }

        fitVideoSize();
        window.addEventListener('resize', () => {
            setTimeout(() => {
                fitVideoSize();
            }, 500);
        });
    }, []);

    return (<div className="main-video">
        <Video ref={props.videoRef} src={process.env.PUBLIC_URL + '/videos/temp_video.mov'} autoPlay loop></Video>
    </div>)
}